import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import MUIDataTable from "mui-datatables";
import RunnerProfileDialog from "../Dialogs/RunnerProfileDialog.jsx";

const styles = theme => ({});

class RaceResultsTable extends React.Component {
  constructor() {
    super();
    this.state = { open: false };
  }

  handleClickOpen = () => {};

  handleClose = () => {
    this.setState({ open: false });
  };
  onRowClick = (rowData, rowMeta) => {
    this.setState({ open: true, rowData: rowData });
  };

  render() {
    const { data, title } = this.props;

    const columns = [
      { name: "Position (overall)", options: { filter: false } },
      { name: "Position (category)", options: { filter: false } },
      { name: "Bib", options: { filter: false, hidden: true } },
      { name: "Name", options: { filter: false } },
      { name: "Category", options: { filter: true } },
      { name: "Time", options: { filter: false } }
    ];
    const options = {
      responsive: "scroll",
      selectableRows: "none",
      onRowClick: this.onRowClick
    };

    return (
      <React.Fragment>
        <RunnerProfileDialog
          open={this.state.open}
          close={this.handleClose}
          runner={this.state.rowData}
        />
        {data.length > 0 && (
          <MUIDataTable
            title={title ? title : "Race results"}
            data={data}
            columns={columns}
            options={options}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RaceResultsTable);
